import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'neon' | 'magenta' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  icon?: ReactNode;
  loading?: boolean;
}

export function Button({
  variant = 'neon',
  size = 'md',
  className,
  icon,
  loading,
  disabled,
  children,
  ...props
}: ButtonProps) {
  const variantClass = {
    neon: 'btn-neon',
    magenta: 'btn-neon-magenta',
    ghost: 'btn-ghost',
    danger:
      'btn-neon border-neon-red text-neon-red hover:shadow-[0_0_20px_rgba(255,56,96,0.4)] hover:bg-neon-red/10',
  }[variant];

  const sizeClass = {
    sm: 'text-xs px-2.5 py-1.5',
    md: 'text-sm px-4 py-2',
    lg: 'text-base px-6 py-3',
  }[size];

  return (
    <button
      className={cn(variantClass, sizeClass, className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        icon
      )}
      {children}
    </button>
  );
}
